import React, { FC } from 'react';

const Footer: FC = () => {
    return (
        <div
            data-testid="universal-footer"
            dangerouslySetInnerHTML={{
                __html: `<!--# block name="footer_fallback" --><!--# endblock --><!--# include virtual="/__universal/footer.html" stub="footer_fallback" -->`
            }}
        />
    );
};

export default Footer;
